module.exports = __webpack_public_path__ + "static/media/brand-icon-default.26e614b6.svg";